
      let Page = require('/home/toannc/ekmap-platform-map-javascript/docs/pages/routing/match.md');
      Page = Page.default || Page;
      module.exports = {
        component: Page,
        props: {
  "frontMatter": {
    "title": "Sắp xếp điểm dữ liệu thành đường đi",
    "description": "Snap to Roads API",
    "topics": [
      "Service"
    ],
    "thumbnail": "direction",
    "order": 3,
    "contentType": "example",
    "layout": "page",
    "hideFeedback": false,
    "language": [
      "JavaScript"
    ],
    "products": [
      "Mapbox GL JS"
    ],
    "prependJs": [
      "import Example from '../../components/example';",
      "import html from './match.html';"
    ]
  }
}
      };
    